import { useState, useEffect } from "react";
import FullCalendar, { formatDate } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import {
  ShowVendorCalenderEvents,
  createEventInCalender,
} from "../../../../context/Slice/CalenderSlice";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";


import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  Modal,
  useTheme,
  styled,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from "@mui/material";
import "./EventCalendar.css";
import Header from "../../../Admin/AdminComponents/Header";
import { tokens } from "../../theme";
import { ShowEvents } from "../../../../context/Slice/EventManagementSlice";

import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const CustomModal = styled(Modal)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .modal-box": {
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 8,
    overflowY: "scroll",
    maxHeight: "80vh",
  },
}));

const EventCalendar = () => {
  const listofevent = useSelector((state) => state.CalenderR.Data);
  const dispatch = useDispatch();
  const [events, setEvents] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vendorMobile, setVendorMobile] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const calendarRef = useRef(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [currentEvents, setCurrentEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const token = secureLocalStorage.getItem("token");
  const [formData, setFormData] = useState({
    client_Name: "",
    client_Email: "",
    mobile_no: "",
    event_Type: "",
    vendor_Category: "",
    vendor_Name: "",
    vendor_Mobile: "",
    // start_Date: "",
    // end_Date: "",
    guests: "",
    total_Amount: "",
    Title: "",
    Description: "",
    Start_Date: "",
    End_Date: "",
    Whole_day: false,
    vendor_id: "",
    coordinator_id: "",
  });

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const id = decoded._id;

        dispatch(ShowVendorCalenderEvents(id)).then((response) => {
          console.log("Response Payload:", response.payload.events); // ✅ Log response payload

          // Check if payload is an array before mapping
          // if (!response.payload || !Array.isArray(response.payload)) {
          //   console.error("Expected an array, but got:", typeof response.payload);
          //   return;
          // }
          const eventData = Array.isArray(response.payload.events)
            ? response.payload.events
            : Object.values(response.payload.events); // ✅ Convert object to array

          console.log(eventData);

          const transformedEvents = eventData.map((event) => ({
            id: event.id,
            title: event.Title,
            start: event.Start_Date,
            end: event.End_Date,
            description: event.Description,
            allDay: event.Whole_day,
          }));

          setEventsData(transformedEvents);
        });
      } catch (error) {
        console.error("Token decoding failed:", error);
      }
    }
  }, [dispatch, token]);

  console.log(listofevent);

  const handleDateClick = (selected) => {
    console.log("Selected date data:", selected);
  
    if (!selected || !selected.startStr) {
      console.error("Invalid date selection");
      return;
    }
  
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for accurate comparison
    const selectedDate = new Date(selected.startStr);
  
    if (selectedDate < today) {
      alert("You cannot select past dates.");
      return;
    }
  
    setFormData((prev) => {
      if (!prev) {
        console.error("formData is undefined.");
        return {};
      }
      return {
        ...prev,
        Start_Date: selected.startStr || "",
        End_Date: selected.endStr || "",
      };
    });
  
    setOpen(true);
  };
  

  // function handleFormSubmit(e) {
  //   e.preventDefault();
  //   console.log(formData)

  // }

  const handleFormSubmit = (e) => {
    e.preventDefault();

    setFormData((prevData) => {
      if (!prevData) {
        console.error("formData is undefined before submission.");
        return {};
      }

      const formatDate = (date) => {
        if (!date) return ""; // Handle empty or undefined date
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      };

      const updatedData = {
        ...prevData,
        Start_Date: formatDate(prevData.Start_Date),
        End_Date: formatDate(prevData.End_Date),
        Proposed_Date: formatDate(prevData.Proposed_Date),
      };

      console.log("Submitting with:", updatedData);

      dispatch(createEventInCalender(updatedData)).then(() => {
        const calendarApi = calendarRef.current?.getApi();
        if (calendarApi) {
          calendarApi.addEvent({
            id: `${updatedData.Start_Date}-${updatedData.Title}`,
            Title: updatedData.Title,
            description: updatedData.Description,
            Start_Date: updatedData.Start_Date,
            Start_Time:updatedData.Start_Time,
            End_Time:updatedData.End_Time,
            End_Date: updatedData.End_Date,
            Whole_day: updatedData.Whole_day,
            vendor_id: updatedData.Vendor_ID,
            coordinator_id: updatedData.Coordinator_id,
          });
        }

        setCurrentEvents((prevEvents) => [...prevEvents, updatedData]);
        setEventsData((prevEvents) => [...prevEvents, updatedData]);
        window.location.reload()

        setOpen(false);
        setFormData({
          client_Name: "",
          client_Email: "",
          mobile_no: "",
          event_Type: "",
          vendor_Name: "",
          vendor_Mobile: "",
          // start_Date: "",
          // end_Date: "",
          guests: "",
          total_Amount: "",
          Title: "",
          Description: "",
          Start_Date: "",
          End_Date: "",
          Whole_day: false,
          vendor_id: "",
          coordinator_id: "",
          Start_Time:"",
          End_Time:""
        });
      });

      return updatedData; // ✅ Ensure `setFormData` gets the updated value
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "client_Name") {
      console.log("Name of the client: ", value);

      const selectedClient = events.find(
        (event) => `${event.User.firstName} ${event.User.lastName}` === value
      );

      console.log("Selected Client: ", selectedClient);

      if (selectedClient) {
        const vendors = selectedClient.Event_Vendors || [];
        console.log("Vendors: ", vendors);

        const vendorCategory =
          vendors.length > 0
            ? vendors
                .map((vendor) => vendor.Budget?.categories[0]?.type || "N/A")
                .join(", ")
            : selectedClient.Budget?.categories.map(
                (category) => category.type
              ) || "N/A";

        console.log(vendorCategory);
        // Reset vendor-related fields when changing client
        setFormData((prev) => ({
          ...prev,
          client_Email: selectedClient.User.email,
          event_Type: selectedClient.EventName,
          mobile_no: selectedClient.User.mobile_number,
          Start_Date: selectedClient.Start_Date || "",
          End_Date: selectedClient.End_Date || "",

          guests: selectedClient.Guest || "",
          vendor_Name: "",
          vendor_Mobile: "", // Reset vendor mobile
          // vendor_Category: vendorCategory,
          serviceName: "",
          total_Amount: selectedClient.Budget.estimatedBudget,
          Description: selectedClient.Description,
          coordinator_id: selectedClient.Coordinator_id,
          Title: selectedClient.EventName,
          Proposed_Date: selectedClient.Proposed_Date,
        }));
      } else {
        console.log("No client found for the given name.");
      }
    }

    if (name === "vendor_Category") {
      console.log(value);
      console.log(filteredData);
      const selectedCategory = value;
      setFormData((prev) => ({
        ...prev,
        serviceName: value,
      }));

      const vendorsForCategory = filteredData.filter(
        (vendor) => vendor.ServiceName === selectedCategory
      );

      console.log(vendorsForCategory);
      setFilteredVendors(vendorsForCategory);
    }

    if (name === "vendor_Name") {
      const selectedVendor = filteredVendors.find(
        (vendor) =>
          `${vendor.Vendor.firstName} ${vendor.Vendor.lastName}` === value
      );

      setFormData((prev) => ({
        ...prev,
        vendor_Name: value,
        vendor_Mobile: selectedVendor
          ? selectedVendor.Vendor.mobile_number
          : "",
      }));
    }
  };

  console.log(currentEvents);

  const HandleBack = () => {
    navigate("/co-ordinator-dashboard");
  };

  async function removeEvent(id) {
    // First, update state to remove the vendor immediately
    try {
      // Make an API request to delete the vendor event
      const res = await axios.delete(
        `${BASE_URL}/api/v1/Calender/DeleteEvent-InCalende/${id}`
      );

      console.log("Vendor removed successfully:", res.data);
    } catch (error) {
      console.error(
        "Error removing vendor:",
        error.response?.data?.message || error.message
      );
      alert("Failed to remove vendor. Please try again.");
    }
  }

  return (
    <Box m="20px">
      <Button
        variant="contained"
        color="secondary"
        onClick={HandleBack}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>
      <h1 className="calendar-heading">Check your scheduled events</h1>
      <Box display="flex" justifyContent="space-between">
        <Box
          flex="1 1 20%"
          backgroundColor={colors.primary[400]}
          p="15px"
          borderRadius="4px"
        >
          <Typography variant="h5">Events</Typography>

          <List>
            {currentEvents.map((event) => (
              <Tooltip
                key={event.id}
                title={
                  <div style={{ padding: "10px", maxWidth: "300px" }}>
                    {" "}
                    {/* Increased padding & width */}
                    <Typography variant="h6" fontWeight="bold">
                      {event.title}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Description:</strong>{" "}
                      {event.extendedProps?.description || "No description"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Start:</strong>{" "}
                      {formatDate(event.start, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </Typography>
                    <Typography variant="body2">
                      <strong>End:</strong>{" "}
                      {event.end
                        ? formatDate(event.end, {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })
                        : "N/A"}
                    </Typography>
                    {/* <Typography variant="body2"><strong>Service Name:</strong> {event.serviceName}</Typography> */}
                  </div>
                }
                arrow
                placement="right"
                sx={{
                  "& .MuiTooltip-tooltip": {
                    fontSize: "1rem", // Increase text size
                    backgroundColor: "#333", // Darker background
                    color: "white",
                    padding: "12px", // More padding
                    maxWidth: "400px", // Wider tooltip
                  },
                }}
              >
                <ListItem
                  key={event.id}
                  sx={{
                    backgroundColor: colors.greenAccent[500],
                    margin: "10px 0",
                    borderRadius: "2px",
                    cursor: "pointer",
                  }}
                >
                  <ListItemText
                    primary={event.title}
                    secondary={formatDate(event.start, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  />
                </ListItem>
              </Tooltip>
            ))}
          </List>
        </Box>
        <Box flex="1 1 100%" ml="15px">
          <FullCalendar
            ref={calendarRef}
            height="75vh"
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
            ]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
            }}
            initialView="dayGridMonth"
            selectable={true}
            editable={true}
            selectMirror={true}
            dayMaxEvents={true}
            events={eventsData} // ✅ Load fetched events here
            select={handleDateClick}
            eventClick={async (selected) => {
              const eventId = selected.event.id; // Get the event ID
              if (window.confirm(`Delete event '${selected.event.title}'?`)) {
                try {
                  await removeEvent(eventId); // Call removeEvent to delete from backend
                  selected.event.remove(); // Remove event from UI
                } catch (error) {
                  console.error("Failed to remove event:", error.message);
                }
              }
            }}
            eventsSet={(events) => setCurrentEvents(events)}
            // ✅ Add Tooltip for Events
            eventContent={(arg) => (
              <Tooltip
                title={
                  <div
                    style={{
                      padding: "15px",
                      maxWidth: "400px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      backgroundColor: "#333",
                      color: "#fff",
                      borderRadius: "8px",
                    }}
                  >
                    <strong
                      style={{ fontSize: "18px", textDecoration: "underline" }}
                    >
                      {arg.event.title}
                    </strong>
                    <br />
                    {arg.event.extendedProps.Description && (
                      <>
                        <em style={{ fontSize: "16px" }}>
                          {arg.event.extendedProps.Description}
                        </em>
                        <br />
                      </>
                    )}
                    <span style={{ fontSize: "14px" }}>
                      Start: {arg.event.start.toLocaleDateString()}
                    </span>
                    <br />
                    {arg.event.end && (
                      <span style={{ fontSize: "14px" }}>
                        End: {arg.event.end.toLocaleDateString()}
                      </span>
                    )}
                  </div>
                }
                arrow
                placement="left"
                PopperProps={{
                  modifiers: [
                    {
                      name: "preventOverflow",
                      options: {
                        boundary: "window",
                      },
                    },
                  ],
                }}
              >
                <div style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                  {arg.event.title}
                </div>
              </Tooltip>
            )}
          />
        </Box>
      </Box>

      <CustomModal open={open} onClose={() => setOpen(false)}>
        <Box className="modal-box">
          <AddBookingPopup
            onClose={() => setOpen(false)}
            handleChange={handleChange}
            setFormData={setFormData}
            formData={formData || {}}
            handleFormSubmit={handleFormSubmit}
            events={events}
            vendors={vendors}
            vendorMobile={vendorMobile}
            filteredVendors={filteredVendors}
            filteredData={filteredData}
            setVendors={setVendors}
            setVendorMobile={setVendorMobile}
            setFilteredVendors={setFilteredVendors}
            setFilteredData={setFilteredData}
            setEvents={setEvents}
          />{" "}
        </Box>
      </CustomModal>
    </Box>
  );
};

export default EventCalendar;

const AddBookingPopup = ({
  onClose,
  setFormData,
  formData,
  handleFormSubmit,
  handleChange,
  events,
  filteredData,
  filteredVendors,
  setEvents,
  setVendors,
  setVendorMobile,
  setFilteredVendors,
  setFilteredData,
}) => {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);

  const token = secureLocalStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const ID = decoded._id;
        dispatch(ShowEvents(ID)).then((response) => {
          if (response.payload && response.payload.events) {
            setEvents(response.payload.events);
          }
        });
      } catch (error) {
        console.error("Token decoding failed:", error);
      }
    }
  }, [dispatch, token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/v1/VendorManagement/show-AllVendorService`
        );
        const fetchedData = response.data.data.allVendorService;
        console.log("Fetched Data:", fetchedData); // Log the fetched data

        const vendorMobileObject = fetchedData.reduce((acc, vendor) => {
          const fullName = `${vendor.Vendor.firstName} ${vendor.Vendor.lastName}`;
          acc[fullName] = vendor.Vendor.mobile_number;
          return acc;
        }, {});

        const Categories = [
          ...new Set(fetchedData.map((data) => data.ServiceName)),
        ];

        const filteredData = fetchedData.filter((data) =>
          Categories.includes(data.ServiceName)
        );

        setFilteredData(filteredData);

        setVendors(
          filteredData.map(
            (vendor) => `${vendor.Vendor.firstName} ${vendor.Vendor.lastName}`
          )
        );
        setVendorMobile(vendorMobileObject);

        setCategories(Categories);
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="popup-container" onClick={onClose}>
    <div className="popup" onClick={(e) => e.stopPropagation()}>
      <h3>Add Event in Calendar</h3>
      <form>
        {/* Row 1: Client Name & Email */}
        <div className="row">
          <div>
            <label>Client Name:</label>
            <select name="client_Name" value={formData?.client_Name || ""} onChange={handleChange} required>
  <option value="">Select Client</option>
  {[...new Map(events.map((event) => [`${event.User.firstName} ${event.User.lastName}`, event])).values()].map(
    (uniqueEvent) => (
      <option key={uniqueEvent.id} value={`${uniqueEvent.User.firstName} ${uniqueEvent.User.lastName}`}>
        {uniqueEvent.User.firstName} {uniqueEvent.User.lastName}
      </option>
    )
  )}
</select>

          </div>
          <div>
            <label>Email:</label>
            <input type="text" name="client_Email" value={formData.client_Email} onChange={handleChange} required />
          </div>
        </div>
  
        {/* Row 2: Mobile & Start Date */}
        <div className="row">
          <div>
            <label>Mobile:</label>
            <input type="text" name="mobile_no" value={formData.mobile_no} onChange={handleChange} required />
          </div>
          <div>
            <label>Total Amount:</label>
            <input type="number" name="total_Amount" value={formData.total_Amount} onChange={handleChange} required />
          </div>
          
        </div>
  
        {/* Row 3: End Date & Vendor Category */}
        <div className="row">
        <div>
            <label>Start Date:</label>
            <input
              type="date"
              name="start_Date"
              value={formData.Start_Date}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => setFormData({ ...formData, Start_Date: e.target.value })}
            />
          </div>
          <div>
            <label>End Date:</label>
            <input
              type="date"
              name="end_Date"
              value={formData.End_Date}
              min={new Date().toISOString().split("T")[0]}

              onChange={(e) => setFormData({ ...formData, End_Date: e.target.value })}
            />
          </div>
          
        </div>
  
        {/* Row 4: Start Time & End Time */}
        <div className="row">
          <div>
            <label>Start Time:</label>
            <input
              type="time"
              name="Start_Time"
              value={formData.Start_Time || ""}
              onChange={(e) => setFormData({ ...formData, Start_Time: e.target.value })}
              required
            />
          </div>
          <div>
            <label>End Time:</label>
            <input
              type="time"
              name="End_Time"
              value={formData.End_Time || ""}
              onChange={(e) => setFormData({ ...formData, End_Time: e.target.value })}
              required
            />
          </div>
        </div>
  
        {/* Row 5: Vendor Name & Total Amount */}
        <div className="row">
        <div>
            <label>Vendor Category</label>
            <select name="vendor_Category" value={formData.vendor_Category || ""} onChange={handleChange}>
              <option value="">Select Category</option>
              {Array.isArray(categories) && categories.length > 0 ? (
                categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))
              ) : (
                <option value="N/A">N/A</option>
              )}
            </select>
          </div>
         
          
          <div>
            <label>Vendor Mobile:</label>
            <input type="text" name="vendor_Mobile" value={formData.vendor_Mobile || ""} readOnly />
          </div> 
        </div>
  
        {/* Row 6: Vendor Mobile & Whole Day Checkbox */}
        <div className="row">
          
        <div>
            <label>Vendor Name</label>
            <select
              name="vendor_Name"
              value={formData.vendor_Name || "Select Vendor"}
              onChange={(e) => {
                const selectedName = e.target.value;
                const selectedVendor = filteredData.find(
                  (data) => `${data.Vendor.firstName} ${data.Vendor.lastName}` === selectedName
                );
                const SelectedVendorId = selectedVendor ? selectedVendor.Vendor_ID : "";
                const vendorMobile = selectedVendor ? selectedVendor.Vendor.mobile_number : "";
                setFormData({
                  ...formData,
                  vendor_Name: selectedName,
                  vendor_Mobile: vendorMobile,
                  vendor_id: SelectedVendorId,
                });
              }}
            >
              <option value="Select Vendor">Select Vendor</option>
              {filteredVendors.length > 0 ? (
                filteredVendors.map((vendor, index) => (
                  <option key={index} value={`${vendor.Vendor.firstName} ${vendor.Vendor.lastName}`}>
                    {vendor.Vendor.firstName} {vendor.Vendor.lastName} - {vendor.TotalBudget}
                  </option>
                ))
              ) : (
                <option value="N/A">No Vendors Available</option>
              )}
            </select>
          </div>
         
        </div>
        <div className="row">
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(formData.Whole_day)}
                  onChange={(e) => setFormData({ ...formData, Whole_day: e.target.checked })}
                  name="Whole_day"
                />
              }
              label="Whole Day"
            />
          </div>
          </div>
  
        {/* Popup Actions */}
        <div className="popup-actions">
          <button type="submit" className="btn-primary" onClick={handleFormSubmit}>
            Submit
          </button>
          <button type="button" className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
  
  );
};
